import { Divider, Grid } from "@mui/material";
import React from "react";
import OkyLogo from "../assets/logo-oky.webp";
import EcosistemasBiLogo from "../assets/newLine/logo-ecosistemas-bi-footer.webp";
import { colors } from "../theme/colors";

export default function Footer() {
  return (
    <div style={{ width: "85%", margin: "auto", marginTop: "2rem" }}>
      <Divider />
      <Grid
        container
        spacing={2}
        justifyContent="center"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      >
        <Grid item sm={4} xs={12}>
          <img src={OkyLogo} alt="okylogo" style={{ maxWidth: "95%" }} />
        </Grid>
        <Grid item sm={4} xs={12}>
          <img
            src={EcosistemasBiLogo}
            alt="EcosistemasBi"
            style={{ maxWidth: "95%" }}
          />
        </Grid>
      </Grid>
      <div
        style={{
          color: colors.primary,
          fontSize: "1rem",
          textAlign: "center",
          marginTop: "65px",
          marginBottom: "100px",
        }}
      >
        2024 © Todos los derechos reservados OKY, Ecosistema Bi.
      </div>
    </div>
  );
}
